export default function () {
  return {
    searches: [],
    searchesCurrentPage: 1,
    searchesLastPage: 1,
    searchesPerPage: 0,
    searchesTotal: 0,
    searchesLoading: false,
    ipsLoading: false,
    ipOrdersLoading: false,
    indexPage: null,
    search: '',
    datefrom: '',
    dateto: ''
  }
}
